import axios from 'axios';

const API_BASE_URL = 'http://localhost:8080/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const BACKEND_BASE = API_BASE_URL.replace(/\/api\/?$/, '');

export function getImageUrl(url: string | undefined): string {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  return BACKEND_BASE + (url.startsWith('/') ? url : '/' + url);
}

export interface Product {
  id?: number;
  name: string;
  description: string;
  imageUrl?: string;
  category?: string;
  isActive?: boolean;
  isFeatured?: boolean;
}

export interface Contact {
  id?: number;
  name: string;
  email: string;
  phone?: string;
  message: string;
  productId?: number;
  isRead?: boolean;
  isSubscribed?: boolean;
  createTime?: string;
}

export interface News {
  id?: number;
  title: string;
  content: string;
  imageUrl?: string;
  isPublished?: boolean;
  publishTime?: string;
  createTime?: string;
}

// Product APIs
export const productApi = {
  getAll: (active?: boolean) => 
    api.get<Product[]>('/products', { params: { active } }),
  getFeatured: () => 
    api.get<Product[]>('/products', { params: { featured: true, active: true } }),
  getById: (id: number) => 
    api.get<Product>(`/products/${id}`),
  create: (product: Product) => 
    api.post<Product>('/products', product),
  update: (id: number, product: Product) => 
    api.put<Product>(`/products/${id}`, product),
  delete: (id: number) => 
    api.delete(`/products/${id}`),
};

// Contact APIs
export const contactApi = {
  getAll: (unread?: boolean) => 
    api.get<Contact[]>('/contacts', { params: { unread } }),
  getById: (id: number) => 
    api.get<Contact>(`/contacts/${id}`),
  create: (contact: Contact) => 
    api.post<Contact>('/contacts', contact),
  markAsRead: (id: number) => 
    api.put<Contact>(`/contacts/${id}/read`),
  delete: (id: number) => 
    api.delete(`/contacts/${id}`),
  subscribe: (email: string) => 
    api.post<Contact>('/contacts/subscribe', { email }),
  getSubscribed: () => 
    api.get<Contact[]>('/contacts/subscribed'),
};

// News APIs
export const newsApi = {
  getAll: (published?: boolean) => 
    api.get<News[]>('/news', { params: { published } }),
  getById: (id: number) => 
    api.get<News>(`/news/${id}`),
  create: (news: News) => 
    api.post<News>('/news', news),
  update: (id: number, news: News) => 
    api.put<News>(`/news/${id}`, news),
  delete: (id: number) => 
    api.delete(`/news/${id}`),
};

export default api;
